module.exports = "/images/circle-marker-car-3-5.png?c5c771b438f88853c62d48781fc2db7a";